export default {
  addUserRoleAction (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("addUserRole", payload)
      resolve()
    })
  }
}
